const externalIdParser = (value, platformId) => JSON.parse(value)?.find(({ MasterPlatformID }) => MasterPlatformID == platformId)?.PlatformPK || null;
const caseInsensitiveParser = (value) => value?.toLowerCase() || null;

export const TABS = {
	PACKAGES_AND_PLACEMENTS: 1,
	CAMPAIGNS: 0
};

export const PLATFORM_MAP = {
	OS: {
		id: 0,
		prefix: "placementManager_"
	},
	GCM: {
		id: 1,
		prefix: "externalPlatform_gcm_",
		label: "Google Campaign Manager",
		campaignNameLookupKey: "Mediaocean (OX)/Prisma",
		legendClass: "csqa-legend-square-gcm",
		platformClass: "csqa-gcm-column",
		platformStickyClass: "csqa-sticky-gcm-column",
		scrollableColumns: {
			packagesPlacements: [
				{ key: "ExternalID", label: "GCM ID", parser: externalIdParser },
				{ key: "TestingStartDate", label: "Testing Start Date", parser: caseInsensitiveParser },
				{ key: "FlightStartDate", label: "Start Date", parser: caseInsensitiveParser },
				{ key: "FlightEndDate", label: "End Date", parser: caseInsensitiveParser },
				{ key: "Compatibility", label: "Compatibility", parser: caseInsensitiveParser },
				{ key: "UnitDimension", label: "Dimensions", parser: caseInsensitiveParser }
			],
			campaign: [
				{ key: "CampaignPK", label: "GCM Campaign ID", parser: externalIdParser },
				{ key: "StartDate", label: "Start Date", parser: caseInsensitiveParser },
				{ key: "EndDate", label: "End Date", parser: caseInsensitiveParser }
			]
		},
		stickyColumns: {
			packagesPlacements: [
				{ key: "PackageName", label: "Package Name" },
				{ key: "PlacementName", label: "Placement Name" }
			],
			campaign: [{ key: "CampaignName", label: "Campaign Name" }]
		}
	},
	PRISMA: {
		id: 5,
		prefix: "externalPlatform_prisma_",
		label: "Prisma",
		campaignNameLookupKey: "Mediaocean (OX)/Prisma",
		legendClass: "csqa-legend-square-prisma",
		platformClass: "csqa-prisma-column",
		platformStickyClass: "csqa-sticky-prisma-column",
		scrollableColumns: {
			packagesPlacements: [
				{ key: "ExternalID", label: "Prisma ID", parser: externalIdParser },
				{ key: "Site", label: "Site", parser: caseInsensitiveParser },
				{ key: "PackageType", label: "Package Type", parser: caseInsensitiveParser },
				{ key: "BuyType", label: "Buy Type", parser: caseInsensitiveParser },
				{ key: "BuyCategory", label: "Buy Category", parser: caseInsensitiveParser },
				{ key: "UnitDimension", label: "Dimensions", parser: caseInsensitiveParser },
				{ key: "Positioning", label: "Positioning", parser: caseInsensitiveParser },
				{ key: "CostMethod", label: "Cost Method", parser: caseInsensitiveParser },
				{ key: "UnitType", label: "Unit Type", parser: caseInsensitiveParser },
				{ key: "UnitRate", label: "Rate", parser: caseInsensitiveParser },
				{ key: "PlannedUnitAmount", label: "Units", parser: caseInsensitiveParser },
				{ key: "PlannedCost", label: "Cost", parser: caseInsensitiveParser },
				{ key: "FlightStartDate", label: "Start Date", parser: caseInsensitiveParser },
				{ key: "FlightEndDate", label: "End Date", parser: caseInsensitiveParser },
				{ key: "ServedBy", label: "Served By", parser: caseInsensitiveParser }
			],
			campaign: [
				{ key: "CampaignPK", label: "Prisma Campaign ID", parser: externalIdParser },
				{ key: "StartDate", label: "Start Date", parser: caseInsensitiveParser },
				{ key: "EndDate", label: "End Date", parser: caseInsensitiveParser },
				{ key: "Budget", label: "Budget", parser: caseInsensitiveParser },
				{ key: "Advertiser", label: "Advertiser", parser: caseInsensitiveParser }
			]
		},
		stickyColumns: {
			packagesPlacements: [
				{ key: "PackageName", label: "Package Name" },
				{ key: "PlacementName", label: "Placement Name" }
			],
			campaign: [{ key: "CampaignName", label: "Campaign Name" }]
		}
	}
};

export const ID_NAME_MAP = {
	1: "GCM",
	5: "PRISMA"
};

export const GCM_PRISMA_COLUMNS = {
	campaignColumns: ["Campaign Name", "GCM Campaign ID", "Prisma Campaign ID", "End Date", "Start Date"],
	packagePlacementColumns: ["Package Name", "Placement Name", "Prisma ID", "GCM ID", "Start Date", "End Date", "Dimensions"]
};
